import React, {Component} from 'react';
import { Dialog, DialogHeader, DialogBody, DialogFooter } from '../../../../presentation/Dialog';
import Overlay from '../../../../presentation/Overlay';

export default class WholesaleUtilityNumberDeleteDialog extends Component {
  constructor( props ) {
    super( props );
    this._isMounted = false; 
    this.state = {
      show:  props.show === undefined ? false : props.show,
      caption:  props.caption === undefined ? false : props.caption,
      message:  props.message === undefined ? false : props.message,
      row: props.row === undefined ? {} : props.row,
      rows: props.rows === undefined ? [] : props.rows
    };

    this.onCancel = this.onCancel.bind( this );
    this.onConfirm = this.onConfirm.bind( this );
  }    

  componentDidMount(){
    this._isMounted=true;
  }

  componentWillReceiveProps( nextProps ) {
    if( this._isMounted === true ) {
      this.setState( { 
        show:  nextProps.show === undefined ? false : nextProps.show,
        caption:  nextProps.caption === undefined ? false : nextProps.caption,
        message:  nextProps.message === undefined ? false : nextProps.message,
        row: nextProps.row === undefined ? {} : nextProps.row,
        rows: nextProps.rows === undefined ? [] : nextProps.rows
      } );
    }
  }

  componentWillUnmount(){
    this._isMounted=false;
  }

  onCancel( e ) {
    if( this._isMounted === true ) {
      if( this.props.onCancel !== undefined ) {
        this.props.onCancel();
      }
    }
  }

  onConfirm() {
    if( this._isMounted === true ) {
      if( this.props.onConfirm !== undefined ) {
        const row = this.state.row;
        const rows = this.state.rows;
        if( row !== undefined && Object.keys( row ).length !== 0 ) {
          this.props.onConfirm( row );
        } else if( rows !== undefined && rows.length !== 0 ) {
          this.props.onConfirm( rows );
        } else {
          this.props.onConfirm( {} );
        }
      }
    }
  }

  onRenderBody() {
    return (
      <span style={{'height':'100%','width':'100%','display':'flex','alignItems':'center','justifyContent':'center','padding':'20px','fontWeight':'bold','color':'red'}}>
        {this.state.message}
      </span>
    );
  }

  onRenderFooter() {
    return (
      <span>
        <button className='dialog-cancel-button' onClick={this.onCancel}>
          Cancel
        </button>
        <button className='dialog-save-button' onClick={this.onConfirm}>
          Confirm
        </button>
      </span>
    );
  }
  render() {
    return (
      <div>
        <Overlay show={this.state.show} />
        <Dialog show={this.state.show} width={30} height={30}>
          <DialogHeader caption={this.state.caption} closeButton onClose={this.onCancel} />
          <DialogBody>
            {this.onRenderBody()}
          </DialogBody>
          <DialogFooter>
            { this.onRenderFooter() }
          </DialogFooter>
        </Dialog>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/content/wholesale/companies/components/WholesaleUtilityNumberDelete.js